import { render, staticRenderFns } from "./Matrice.vue?vue&type=template&id=b28b30aa&"
import script from "./Matrice.vue?vue&type=script&lang=ts&"
export * from "./Matrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports